import React from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";

class CompanyDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggle = () => {
    const { domains } = this.props;
    if (domains && domains.length > 1) {
      this.setState({ isOpen: !this.state.isOpen });
    }
  };

  renderDropdownItem = (item) => {
    return (
      <a key={item.url} href={item.url}>
        <DropdownItem>{item.company}</DropdownItem>
      </a>
    );
  };

  render() {
    const { domains } = this.props;
    return (
      <Dropdown
        inNavbar
        direction="down"
        isOpen={this.state.isOpen}
        toggle={this.toggle}
      >
        {domains && domains.length > 1 && (
          <DropdownMenu>{domains.map(this.renderDropdownItem)}</DropdownMenu>
        )}
        <DropdownToggle
          tag="h4"
          onClick={this.toggle}
          data-toggle="dropdown"
          className="mb-0"
          style={{ fontSize: "17.5px" }}
          caret={domains && domains.length > 1}
        >
          {this.props.client.company}
        </DropdownToggle>
      </Dropdown>
    );
  }
}

export default CompanyDropdown;
